export default "__VITE_ASSET__67e91dc7__"